// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1lc1e","loaderOuter":"PageOverlayLoader_loaderOuter__211Q4"};